import { useTranslation } from 'react-i18next';

const SwitchLang = ({ previewLang, setPreviewLang, className }) => {
    const { t } = useTranslation();
    return (
        <div className={`flex space-x-2 text-tiny ${className}`}>
            <span
                style={{ borderRight: '1px solid #65707A' }}
                onClick={() => {
                    setPreviewLang('th');
                }}
                className={`${
                    previewLang === 'th' ? 'text-purple-PHX font-semibold' : ''
                } cursor-pointer hover:opacity-80 pr-2`}
            >
                {t('Thai')}
            </span>
            <span
                onClick={() => {
                    setPreviewLang('en');
                }}
                className={`${
                    previewLang === 'en' ? 'text-purple-PHX font-semibold' : ''
                } cursor-pointer hover:opacity-80`}
            >
                {t('English')}
            </span>
        </div>
    );
};

export default SwitchLang;
